/**
 * @file  title/index.tsx
 * @description title element (H 1..5)
 *
 * @example <Title level=[1,2,3,4,5] />
 *
 * @author ogarcia (ozkary)
 *
 */
import React from 'react';
import * as S from './styles';

/**
 * @description layout styled element
 *
 * @param Props
 */
const Title = ({ level, className, children }: S.Props): JSX.Element => (
  <S.Title level={level || 1} className={className}>
    {children}
  </S.Title>
);

export default Title;
